/* Mayberry — theme.js (vanilla, no deps) */
(function () {
  'use strict';

  var openDrawer = null;

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initHeader();
    initDrawers();
    initMobileNav();
    initCarousels();
    initSlideshow();
    initQty();
    initProductForm();
    initGallery();
    initSort();
    initSpotlight();
  });

  /* ---------- Announcement rotation ---------- */
  function initAnnouncement() {
    var bar = document.querySelector('[data-announcement]');
    if (!bar) return;
    var messages = bar.querySelectorAll('.announcement-message');
    if (!messages.length) return;
    messages[0].classList.add('is-active');
    if (messages.length < 2) return;
    var speed = (parseInt(bar.getAttribute('data-speed'), 10) || 3) * 1000;
    var i = 0;
    setInterval(function () {
      messages[i].classList.remove('is-active');
      i = (i + 1) % messages.length;
      messages[i].classList.add('is-active');
    }, speed);
  }

  /* ---------- Sticky header state ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Drawers ---------- */
  function initDrawers() {
    var overlays = document.querySelectorAll('[data-drawer-overlay]');

    function setDrawer(name, open) {
      var drawer = document.querySelector('[data-drawer="' + name + '"]');
      var overlay = document.querySelector('[data-drawer-overlay="' + name + '"]');
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (overlay) overlay.classList.toggle('is-open', open);
      document.body.classList.toggle('no-scroll', open);
      openDrawer = open ? name : null;
    }

    document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setDrawer(btn.getAttribute('data-drawer-open'), true);
      });
    });

    document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setDrawer('cart', true);
      });
    });

    document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = btn.closest('[data-drawer]');
        setDrawer(d ? d.getAttribute('data-drawer') : 'cart', false);
      });
    });

    overlays.forEach(function (ov) {
      ov.addEventListener('click', function () {
        setDrawer(ov.getAttribute('data-drawer-overlay'), false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openDrawer) setDrawer(openDrawer, false);
    });

    window.setDrawerOpen = function (name) { setDrawer(name, true); };
  }

  /* ---------- Mobile nav accordions ---------- */
  function initMobileNav() {
    document.querySelectorAll('.drawer-nav-item__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var parent = btn.closest('.drawer-nav-item--parent');
        var sub = parent ? parent.querySelector(':scope > .drawer-nav-item__sublist') : null;
        var open = parent ? parent.classList.toggle('is-open') : false;
        if (sub) sub.style.display = open ? 'block' : '';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Carousels ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track) return;
      var scrollByCard = function (dir) {
        var card = track.querySelector('.card');
        var amount = card ? card.getBoundingClientRect().width + 20 : 300;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });
    });
  }

  /* ---------- Slideshow ---------- */
  function initSlideshow() {
    document.querySelectorAll('[data-slideshow]').forEach(function (slideshow) {
      var track = slideshow.querySelector('.slideshow__track');
      var slides = slideshow.querySelectorAll('[data-slide]');
      if (!track || slides.length < 2) return;
      var current = 0;
      var timer = null;
      var autoplay = slideshow.getAttribute('data-autoplay') === 'true';
      var interval = parseInt(slideshow.getAttribute('data-interval'), 10) || 5000;
      var dotsWrap = slideshow.querySelector('[data-slide-dots]');
      var dots = [];

      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var d = document.createElement('button');
          d.className = 'slideshow__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          d.addEventListener('click', function () { go(i); restart(); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }

      function go(i) {
        current = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-current * 100) + '%)';
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === current); });
      }

      function restart() {
        if (timer) clearInterval(timer);
        if (autoplay) timer = setInterval(function () { go(current + 1); }, interval);
      }

      var prevBtn = slideshow.querySelector('[data-slide-prev]');
      var nextBtn = slideshow.querySelector('[data-slide-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1); restart(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1); restart(); });
      slideshow.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
      slideshow.addEventListener('mouseleave', restart);
      restart();
    });
  }

  /* ---------- Quantity steppers + AJAX updates ---------- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var qty = (minus || plus).closest('[data-qty]');
      var input = qty ? qty.querySelector('[data-qty-input]') : null;
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v = minus ? v - 1 : v + 1;
      if (v < 1) v = 1;
      input.value = v;
      if (input.hasAttribute('data-line')) {
        updateCartLine(parseInt(input.getAttribute('data-line'), 10), v);
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input][data-line]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 0;
      updateCartLine(parseInt(input.getAttribute('data-line'), 10), v);
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-remove]');
      if (!link) return;
      e.preventDefault();
      var item = link.closest('[data-line-item]');
      var line = item ? parseInt(item.getAttribute('data-line'), 10) : null;
      if (!line) { window.location.href = link.href; return; }
      if (item) item.remove();
      updateCartLine(line, 0);
    });
  }

  function updateCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('change failed');
        return res.json();
      })
      .then(function (cart) {
        if (cart.item_count === 0) { window.location.reload(); return; }
        refreshCartUI(cart);
        if (document.querySelector('.cart-page')) { window.location.reload(); return; }
        rebuildCartDrawer(cart);
      })
      .catch(function () { window.location.reload(); });
  }

  /* ---------- Product form (variants + AJAX add) ---------- */
  function initProductForm() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var json = form.getAttribute('data-product-json');
      var priceEl = document.querySelector('[data-price]');
      var compareEl = document.querySelector('[data-compare]');
      var selects = Array.prototype.slice.call(form.querySelectorAll('[data-option-select]'));
      var addBtn = form.querySelector('[data-add-to-cart]');
      var labelEl = addBtn ? addBtn.querySelector('[data-add-label]') : null;

      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          if (!json) return;
          try {
            var product = JSON.parse(json);
            var chosen = {};
            selects.forEach(function (s) {
              chosen[s.name.replace(/^options\[/, '').replace(/\]$/, '')] = s.value;
            });
            var variant = product.variants.find(function (v) {
              return product.options.every(function (opt, idx) {
                return v.options[idx] === chosen[opt];
              });
            });
            if (!variant) return;
            if (priceEl) {
              priceEl.textContent = formatMoney(variant.price, '');
              priceEl.classList.toggle('is-sale', variant.compare_at_price > variant.price);
            }
            if (compareEl) {
              if (variant.compare_at_price > variant.price) {
                compareEl.textContent = formatMoney(variant.compare_at_price, '');
                compareEl.style.display = '';
              } else {
                compareEl.style.display = 'none';
              }
            }
            if (labelEl) labelEl.textContent = variant.available ? 'Add to cart' : 'Sold out';
            if (addBtn) addBtn.disabled = !variant.available;
          } catch (err) { /* noop */ }
        });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var addBtn = form.querySelector('[data-add-to-cart]');
        if (addBtn && addBtn.disabled) return;
        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function () {
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            refreshCartUI(cart);
            rebuildCartDrawer(cart);
            if (window.setDrawerOpen) window.setDrawerOpen('cart');
          })
          .catch(function () { window.location.href = '/cart'; });
      });
    });
  }

  /* ---------- Gallery thumbs ---------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('.product__main-img');
      gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (main) main.src = thumb.getAttribute('data-url');
        });
      });
    });
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    document.querySelectorAll('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Spotlight: color/size pills ---------- */
  function initSpotlight() {
    document.querySelectorAll('[data-spotlight-colors]').forEach(function (wrap) {
      wrap.querySelectorAll('.spotlight__swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          wrap.querySelectorAll('.spotlight__swatch').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    });
    document.querySelectorAll('[data-spotlight-sizes]').forEach(function (wrap) {
      wrap.querySelectorAll('.spotlight__size').forEach(function (btn) {
        btn.addEventListener('click', function () {
          wrap.querySelectorAll('.spotlight__size').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    });
    document.querySelectorAll('[data-spotlight-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.setDrawerOpen) window.setDrawerOpen('cart');
      });
    });
  }

  /* ---------- Cart UI helpers ---------- */
  function refreshCartUI(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price, cart.currency);
    });
    updateShippingBar(cart);
  }

  function updateShippingBar(cart) {
    var bar = document.querySelector('[data-shipping-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 7500;
    var teaser = bar.getAttribute('data-teaser') || "You're {amount} away from FREE shipping!";
    var reached = bar.getAttribute('data-reached') || "You've unlocked FREE U.S. shipping!";
    var msgEl = bar.querySelector('[data-progress-message]');
    var fillEl = bar.querySelector('.cart-drawer__progress-fill');
    var total = (cart && cart.total_price) || 0;
    var remaining = threshold - total;
    if (msgEl) {
      if (remaining > 0) {
        var amount = formatMoney(remaining, 'USD');
        msgEl.textContent = teaser.split('{amount}').join(amount);
      } else {
        msgEl.textContent = reached;
      }
    }
    if (fillEl) {
      var pct = remaining > 0 ? Math.max(0, Math.min(100, Math.round((total / threshold) * 100))) : 100;
      fillEl.style.width = pct + '%';
    }
  }

  function rebuildCartDrawer(cart) {
    var drawer = document.querySelector('[data-drawer="cart"]');
    if (!drawer) return;
    var body = drawer.querySelector('.cart-drawer__body');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<p class="cart-drawer__empty-text">Your cart is currently empty.</p>' +
        '<a class="btn btn--solid" href="/collections/all">Continue shopping</a>' +
        '</div>';
      return;
    }

    var itemsHtml = cart.items.map(function (item, i) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="" loading="lazy">'
        : '';
      var variant = item.variant_title
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';
      return (
        '<li class="cart-drawer__item" data-line-item data-line="' + (i + 1) + '">' +
        '<a class="cart-drawer__item-media" href="' + item.url + '">' + img + '</a>' +
        '<div class="cart-drawer__item-info">' +
        '<a class="cart-drawer__item-title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
        variant +
        '<div class="cart-drawer__item-bottom">' +
        '<div class="qty" data-qty>' +
        '<button type="button" data-qty-minus aria-label="Decrease quantity">−</button>' +
        '<input type="number" value="' + item.quantity + '" min="0" data-qty-input data-line="' + (i + 1) + '">' +
        '<button type="button" data-qty-plus aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price, cart.currency) + '</span>' +
        '</div>' +
        '<a class="cart-drawer__item-remove" href="/cart/change?line=' + (i + 1) + '&quantity=0" data-remove>Remove</a>' +
        '</div></li>'
      );
    }).join('');

    body.innerHTML =
      '<form action="/cart" method="post" class="cart-drawer__form">' +
      '<ul class="cart-drawer__items">' + itemsHtml + '</ul>' +
      '<div class="cart-drawer__foot">' +
      '<div class="cart-drawer__subtotal"><span>Subtotal</span><span data-cart-subtotal>' +
      formatMoney(cart.total_price, cart.currency) + '</span></div>' +
      '<p class="cart-drawer__note">Shipping, taxes, and discount codes calculated at checkout.</p>' +
      '<button type="submit" name="checkout" class="btn btn--solid btn--full">Check out</button>' +
      '<a class="cart-drawer__continue" href="/collections/all">or continue shopping</a>' +
      '</div></form>';
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format((cents || 0) / 100);
    } catch (err) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }
})();
